/*
 * This file contains all functions to control the leaderboard page.
 */

let currentTable = "monthly";

function switchToTable(id) {
    if (currentTable === id) {
        return;
    }

    $(`#${id}`).removeClass("d-none");
    $(`#${currentTable}`).addClass("d-none");
    currentTable = id;
    $("#tableTitle").text(trans.leaderboards[id]);
}

window.switchToTable = switchToTable;
